import React from 'react';
import { Box, Link } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import "../../../formLayout.scss";
import UGTable from "../../../Supporting files/UGTable/UGTable";
import SlidingPanel from "react-sliding-side-panel";
import { ClassNames } from '@emotion/react';

function LocationTable() {
    const [columns, setColumns] = React.useState([
        {
            field: "claim_id",
            headerName: "Claim ID",
            flex: 2,
            minWidth: 150,
            check_status: true,
        },
        {
            field: "client_id",
            headerName: "Client ID",
            flex: 4,
            minWidth: 150,
            check_status: true,
        },
        {
            field: "client_name",
            headerName: "Client Name",
            flex: 8,
            minWidth: 150,
            check_status: true,
        },
        {
            field: "employee_id",
            headerName: "employee ID",
            flex: 3,
            minWidth: 200,
            check_status: true,
        },
        {
            field: "employee_name",
            headerName: "Employee Name",
            flex: 1,
            minWidth: 200,
            check_status: true,
        },
        {
            field: "policy",
            headerName: "Policy",
            flex: 1,
            minWidth: 150,
            check_status: true,
        },
        {
            field: "type",
            headerName: "Type",
            flex: 1,
            minWidth: 100,
            check_status: true,
        },
        {
            field: "status",
            headerName: "Status",
            flex: 2,
            minWidth: 100,
            check_status: true,
        },
        {
            field: "insurer",
            headerName: "Insurer",
            flex: 2,
            minWidth: 100,
            check_status: true,
        },
    ]);
    const rows = [ ];
    const updateMasterState = (attrName: any, value: string) => {
        attrName(value);
    };
    return (
        <Box className="detailSection mb-10">
            <div className="sectionTitle mb-0">
                <h4>Locations</h4>

                <div className="actionBtns">
                    <Link
                        className="redBtn delete"
                        onClick={() => {
                            // setopenLocation(true);
                        }}
                        sx={{ textDecoration: "none", cursor: "pointer" }}>
                        Delete
                    </Link>
                    <Link
                        className="blueBtn addfile"
                        onClick={() => {
                            // setopenLocation(true);
                        }}
                        sx={{ textDecoration: "none", cursor: "pointer" }}>
                        Add Location
                    </Link>
                </div>
            </div>
            <Grid container>
                <Grid xs={12} className="mt-5">
                    <UGTable
                        header_data={columns}
                        data={[]}
                        value_update={updateMasterState}
                        attrName={"UGTable"}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}

export default LocationTable